import { Button, Stack, Typography } from "@mui/material";
import { colours } from "../../../StyleConstants";
import LassoModal from "../../../components/LassoModal";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import { useNavigate } from "react-router-dom";
import React from "react";


const PiModal = (props: any) => {

    const navigate = useNavigate()

    const handleClickIndividual = (type: string) => {
        localStorage.setItem('formType', type)
        localStorage.setItem('isGroup', "false")
        localStorage.setItem('AddSub', JSON.stringify(false))
        navigate( "/duc/request");
    }
    const handleClickGroup = (type: string) => {
        localStorage.setItem('formType', type)
        localStorage.setItem('isGroup', "true")
        localStorage.setItem('AddSub', "false")
        navigate( "/duc/request");
    }

    return (
        <LassoModal open={props.open}>
            <Stack gap={4} padding="10px">
                <Stack flexDirection="row" justifyContent="space-between">
                    <Typography variant="h5" fontWeight="600" color={colours.midnightBlue.blue}>
                        Access Request Type
                    </Typography>
                    <HighlightOffIcon onClick={() => {props.setOpen(false)}}/>
                </Stack>
                <Stack gap={1}>
                    <Typography color={colours.midnightBlue.blue}>
                        Choose between the two Data Use Certification (DUC) options below:
                    </Typography>
                    <Typography color={colours.midnightBlue.blue}>
                        <strong>Individual DUC</strong>: Request access for yourself only.
                    </Typography>
                    <Typography color={colours.midnightBlue.blue}>
                        <strong>Investigator-Led Group DUC</strong>: You are a research investigator requesting access for yourself and any number of additional people in your group
                    </Typography>
                </Stack>

                <Stack flexDirection="row" alignSelf="center" gap={2}>
                    <Button
                        id="duc-individual-button"
                        variant="primary"
                        startIcon={<PersonOutlineOutlinedIcon/>}
                        onClick={() => handleClickIndividual(props.type)}
                    >
                        Individual DUC
                    </Button>
                    <Button
                        id="duc-investigator-led-group-button"
                        variant="secondary"
                        startIcon={<PeopleOutlineOutlinedIcon/>}
                        onClick={() => handleClickGroup(props.type)}
                    >
                        Investigator-Led Group DUC
                    </Button>
                </Stack>

            </Stack>
        </LassoModal>
    )
}

export default PiModal